<template>
	<div class="content text-white">
		<div class="text-3.5xl pb-3">Manage Account</div>
		<div class="text-xs mb-8">Account & Settings > Manage Account</div>

		<div class="grid grid-cols-70-30 gap-12">
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<div class="text-sm font-bold mb-1">Account List</div>
					<div class="text-xs">You can save up to 3 additional verified account numbers</div>
				</div>

				<div class="card p-5 mb-0.5">
					<template v-if="isLoadingBankListApproved">
						<div class="flex justify-center items-center">
							<Loader />
						</div>
					</template>

					<template v-else>
						<div v-for="item in bankListApproved" :key="item._id">
							<div class="flex items-center gap-3">
								<div class="w-6">
									<!-- <LogoAbi size_prop="1.5em" /> -->
									<img :src="item.bankLogo" alt="Logo" class="dropdown-logo" />
								</div>

								<div class="text-xs">
									<div class="mb-1">{{ item.accountName }} <span
											:class="[`${item.status == 'Verified' ? 'success' : 'gold'}`, 'ml-2']">{{ item.status
											}}</span>
									</div>

									<div>{{ item.bankName }} - {{ item.accountNumber }}</div>


								</div>

								<div v-if="item.type == 'etb' && !item.canDelete" class="grow text-right text-grey text-xs">
									Primary Withdrawal Account
								</div>

								<div v-if="item.canDelete" class="grow text-right" @click="deleteApprovedBankAccount(item._id)">
									<IconTrash class="cursor-pointer" />
								</div>
							</div>

							<div v-if="item.status != 'Verified'" class="flex items-center gap-3">
								<div class="w-6">
								</div>

								<div class="text-xs">
									<div class="text-grey mt-3">
										Proses verifikasi kurang lebih 1 hari
									</div>
								</div>
							</div>

							<hr class="bg-grey-1">
						</div>
					</template>

					<div class="mb-5"></div>

					<div class="">
						<router-link :to="{ name: 'Add Bank Account' }">
							<div class="text-xs font-medium text-theme cursor-pointer">Add Account</div>
						</router-link>
					</div>

				</div>
			</div>

			<!-- Daftar Rekening Penerima -->
			<div>

			</div>
		</div>
	</div>
</template>

<script>
import useBankAccount from '../../composable/useBankAccount'

import Banner from '@/components/Banner.vue'
import Select from '@/components/ui/Select.vue'
import LogoAbi from '@/components/logo/LogoAbi.vue'
import Alert from '@/components/alert-component/AlertComponent.js'
import router from '../../router'
import IconTrash from '../../components/icons/IconTrash.vue'
import Loader from '../../components/Loader.vue'
import Breadcrumbs from '../../components/Breadcrumbs.vue'

export default {
	name: 'RekeningPenarikan',

	mixins: [useBankAccount],

	components: {
		Banner,
		Select,
		LogoAbi,
		IconTrash,
		Loader,
		Breadcrumbs
	},
	data() {
		return {
			bank: '',
		}
	},

	created() {
		this.setBankListApproved()
	},

	methods: {
	},

}
</script>

<style scoped>
.norek {
	margin-bottom: 0.125rem;
}

.card {
	background-color: var(--grey-4-color);
}

.logo-bagi {
	width: 1.5em;
	height: 1.5em;
}
</style>